import React from 'react'
import { Card, CardActions, CardText } from 'material-ui-legacy/Card'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'

import errors from '../../lib/errors.js'
import auth from '../../stores/auth.js'
import ErrorDialog from '../UI/ErrorDialog'
import ValidatedPasswordInput from '../UI/ValidatedPasswordInput'
import ValidatedTextInput from '../UI/ValidatedTextInput'
import SaveButton from '../UI/SaveButton'
import PageTitle from '../UI/PageTitle'

class Login extends React.PureComponent {
  constructor(props) {
    super(props)

    // Start with a clean slate
    auth.logout()
    window.history.replaceState({}, '', '/login')

    this.state = {
      email: '',
      password: '',
      error: '',
      submitting: false
    }
  }

  _change = (value, valid, attribute) => {
    let updates = {}
    updates[attribute] = value
    this.setState(updates)
  }

  _submit = () => {
    this.setState({ submitting: true })
    auth
      .login(this.state.email, this.state.password)
      .then(() => (window.location.href = '/')) // Yes, we're reloading. Sue me.
      .catch(error =>
        this.setState({
          submitting: false,
          error: errors.unpack(error)
        })
      )
  }

  _detectEnter = ev => {
    if (ev.key === 'Enter') this._submit()
  }

  _closeErrorDialog = () => this.setState({ error: null })

  render() {
    return (
      <section>
        <Row>
          <Col sm={12} md={8} md-offset={2}>
            <PageTitle>Login</PageTitle>

            <Card>
              <CardText>
                <ValidatedTextInput
                  name="email"
                  errorMessage="Invalid email"
                  hintText="email@example.com"
                  floatingLabelText="Email (required)"
                  pattern={/.+@.+\..+/}
                  fullWidth
                  required
                  value={this.state.email}
                  validatedOnChange={this._change}
                  onKeyPress={this._detectEnter}
                  immediateValidation
                />

                <ValidatedPasswordInput
                  name="password"
                  value={this.state.password}
                  floatingLabelText="Password (required)"
                  fullWidth
                  required
                  validatedOnChange={this._change}
                  onKeyPress={this._detectEnter}
                  immediateValidation
                />
              </CardText>

              <CardActions style={{ textAlign: 'center' }}>
                >
                <SaveButton
                  label="Login"
                  onTouchTap={this._submit}
                  disabled={this.state.submitting}
                />
              </CardActions>
            </Card>
          </Col>
        </Row>

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't log in"
        >
          <p>Please verify your email and password.</p>
          <p>
            If you don't have a login yet, please contact the system
            administrator.
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/components/Users/Login.jsx